import { render, staticRenderFns } from "./news1.vue?vue&type=template&id=539e8259&scoped=true"
import script from "./news1.vue?vue&type=script&lang=js"
export * from "./news1.vue?vue&type=script&lang=js"
import style0 from "./news1.vue?vue&type=style&index=0&id=539e8259&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539e8259",
  null
  
)

export default component.exports